import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-page-reading-girls',
    templateUrl: './page-reading-girls.component.html',
    styleUrls: ['./page-reading-girls.component.css'],
    standalone: false
})
export class PageReadingGirlsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
